<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>
 import moment from 'moment';

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('appraisalexerciserecords.appraisalexerciselist'),
      dataHeader: [

        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('appraisalexerciserecords.appraisalexercise'), value: "appexercisecode", width: "120px" },
        { text: this.$t('appraisalexerciserecords.appraisalexercisedescription'), value: "appexercisedesc", width: "200px" },
        { text: this.$t('appraisalrecord.periodfrom'), value: "startdate", width: "200px" },
        { text: this.$t('appraisalrecord.perioduntil'), value: "enddate", width: "200px" },
        { text: this.$t('appraisalexerciserecords.assesmenttype'), value: "assessmenttypedesc", width: "200px" },
        { text: this.$t('rangkingset'), value: "rankingsetdesc", width: "200px" },
        { text: this.$t('columns.remark'), value: "remarks", width: "200px" },

       
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
       search: this.$route.params.search,
    };
  },

  methods: {
    getAppraisalExerciseHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/appraisalexercise/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;

           for (let i = 0; i < vm.dataItems.length; i++) {
                    if (vm.dataItems[i].startdate) {
                        vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
                    }

                    if (vm.dataItems[i].enddate) {
                        vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
                    }
                 }


          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "appraisalexerciseedit", params: { id: item.id, search: item.search  } });
    },

    newRecordHandler() {
      this.$router.push({ name: "appraisalexercisenew" });
    },
  },
  mounted() {
    this.getAppraisalExerciseHandler();
  },
};
</script>